export default __webpack_public_path__ + "static/media/151-driller.e6498d51.png";